"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return CalendarViewColumn;
    }
});
const _View = /*#__PURE__*/ _interop_require_default(require("~/models/View"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _extractProps = require("~/helpers/extractProps");
const _serialize = require("~/utils/serialize");
const _globals = require("~/utils/globals");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let CalendarViewColumn = class CalendarViewColumn {
    static async get(context, calendarViewColumnId, ncMeta = _Noco.default.ncMeta) {
        let viewColumn = calendarViewColumnId && await _NocoCache.default.get(context, `${_globals.CacheScope.CALENDAR_VIEW_COLUMN}:${calendarViewColumnId}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!viewColumn) {
            viewColumn = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.CALENDAR_VIEW_COLUMNS, calendarViewColumnId);
            if (viewColumn) {
                viewColumn.meta = viewColumn.meta && typeof viewColumn.meta === 'string' ? JSON.parse(viewColumn.meta) : viewColumn.meta;
                await _NocoCache.default.set(context, `${_globals.CacheScope.CALENDAR_VIEW_COLUMN}:${calendarViewColumnId}`, viewColumn);
            }
        }
        return viewColumn && new CalendarViewColumn(viewColumn);
    }
    static async insert(context, column, ncMeta = _Noco.default.ncMeta) {
        const insertObj = (0, _extractProps.extractProps)(column, [
            'fk_view_id',
            'fk_column_id',
            'show',
            'base_id',
            'source_id',
            'underline',
            'bold',
            'italic'
        ]);
        insertObj.order = await ncMeta.metaGetNextOrder(_globals.MetaTable.CALENDAR_VIEW_COLUMNS, {
            fk_view_id: insertObj.fk_view_id
        });
        if (!insertObj.source_id) {
            const viewRef = await _View.default.get(context, insertObj.fk_view_id, ncMeta);
            insertObj.source_id = viewRef.source_id;
        }
        const { id } = await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.CALENDAR_VIEW_COLUMNS, insertObj);
        {
            const view = await _View.default.get(context, column.fk_view_id, ncMeta);
            await _View.default.clearSingleQueryCache(context, view.fk_model_id, [
                view
            ], ncMeta);
        }
        return this.get(context, id, ncMeta).then(async (viewColumn)=>{
            await _NocoCache.default.appendToList(context, _globals.CacheScope.CALENDAR_VIEW_COLUMN, [
                column.fk_view_id
            ], `${_globals.CacheScope.CALENDAR_VIEW_COLUMN}:${id}`);
            return viewColumn;
        });
    }
    static async list(context, viewId, ncMeta = _Noco.default.ncMeta) {
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.CALENDAR_VIEW_COLUMN, [
            viewId
        ]);
        let { list: viewColumns } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !viewColumns.length) {
            viewColumns = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.CALENDAR_VIEW_COLUMNS, {
                condition: {
                    fk_view_id: viewId
                },
                orderBy: {
                    order: 'asc'
                }
            });
            for (const viewColumn of viewColumns){
                viewColumn.meta = (0, _serialize.deserializeJSON)(viewColumn.meta);
            }
            await _NocoCache.default.setList(context, _globals.CacheScope.CALENDAR_VIEW_COLUMN, [
                viewId
            ], viewColumns);
        }
        viewColumns.sort((a, b)=>(a.order != null ? a.order : Infinity) - (b.order != null ? b.order : Infinity));
        return viewColumns == null ? void 0 : viewColumns.map((v)=>new CalendarViewColumn(v));
    }
    static async update(context, columnId, body, ncMeta = _Noco.default.ncMeta) {
        const updateObj = (0, _extractProps.extractProps)(body, [
            'show',
            'order',
            'underline',
            'bold',
            'italic'
        ]);
        // update meta
        const res = await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.CALENDAR_VIEW_COLUMNS, updateObj, columnId);
        await _NocoCache.default.update(context, `${_globals.CacheScope.CALENDAR_VIEW_COLUMN}:${columnId}`, updateObj);
        // on view column update, delete any optimised single query cache
        {
            const viewCol = await this.get(context, columnId, ncMeta);
            const view = await _View.default.get(context, viewCol.fk_view_id, ncMeta);
            await _View.default.clearSingleQueryCache(context, view.fk_model_id, [
                view
            ]);
        }
        return res;
    }
    constructor(data){
        Object.assign(this, data);
    }
};
